import { render, staticRenderFns } from "./confirmDelete.vue?vue&type=template&id=4dbf52ad&scoped=true&"
import script from "./confirmDelete.vue?vue&type=script&lang=ts&"
export * from "./confirmDelete.vue?vue&type=script&lang=ts&"
import style0 from "./confirmDelete.vue?vue&type=style&index=0&id=4dbf52ad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbf52ad",
  null
  
)

export default component.exports